export default __webpack_public_path__ + "static/media/Helm of the Furious Swipe.05b7f9b7.jpg";